export const contactReasonOptions = [
  { label: 'Request Technical Support', value: 'support' },
  { label: 'General Inquiry', value: 'inquiry' },
  { label: 'Bug Report', value: 'bug' },
  { label: 'Feedback', value: 'feedback' },
  { label: 'Other', value: 'Other' },
];

export const jiraIntegrationBenefits = [
  'Create and update issues',
  'Sync test cases and Jira issues',
  'Streamline project and issue tracking',
];

export const jiraChangeWarning = (type) => {
  return (
    <>
      <p>
        <strong>Warning:</strong> Changing the {type === 'site' ? 'JIRA site' : 'JIRA project'} will lead to the
        following consequences:
      </p>
      <ul>
        <li>The JIRA project will be disconnected from your GAINSS project.</li>
        <li>
          Issues linked to test cases or test cycles will be removed from GAINSS
          (JIRA issues will not be affected).
        </li>
        <li>
          Release versions associated with test cases will be removed, if
          applicable.
        </li>
      </ul>
    </>
  );
};

export const roleOptions = [
  { label: 'Team Member', value: 'team-member' },
  { label: 'Organization Manager', value: 'org-manager' },
  { label: 'Executive Manager', value: 'executive-manager' },
];


export const RELEASE_NOTE_ITEM_ALLOWED_TYPES = ['Feature', 'Improvement', 'Bugfix'];
